import { AwsApiClient } from '@aws/aws-core-plugin-for-backstage-react';

class AwsCodePipelineApiClient extends AwsApiClient {
  constructor(options) {
    super({
      backendName: "aws-codepipeline",
      ...options
    });
  }
  async getPipelineExecutionsByEntity({
    entity
  }) {
    const urlSegment = `v1/entity/${encodeURIComponent(
      entity.namespace
    )}/${encodeURIComponent(entity.kind)}/${encodeURIComponent(
      entity.name
    )}/executions`;
    const services = await this.get(urlSegment);
    return services;
  }
  async getPipelineStateByEntity({
    entity
  }) {
    const urlSegment = `v1/entity/${encodeURIComponent(
      entity.namespace
    )}/${encodeURIComponent(entity.kind)}/${encodeURIComponent(
      entity.name
    )}/state`;
    const services = await this.get(urlSegment);
    return services;
  }
}

export { AwsCodePipelineApiClient };
//# sourceMappingURL=AwsCodePipelineApiClient.esm.js.map
